const th = {
  comments: {
    username: 'Nickname',
    email: 'E-mail',
    submit: 'Submit',
    loginToContinue: 'Please login',
    replyComment: 'Reply',
    loadMoreComments: 'More',
    private: 'Private',
    public: 'I wish to public this comment for everyone.',
    contentIsEmpty: 'Please fill the question content.',
    recaptchIsNotChecked: 'Please complete the reCAPTCHA.',
    qaTitle: 'FAQ',
    platformQuestion: 'Platform',
    contestQuestion: 'Contest',
    goToQuestion: 'I want to ask',
    similarCommentNeedReviewingTitle: 'Your comment is under reviewing',
    similarCommentNeedReviewingContent: 'You submitted similar comments in a short time, we\'d need to review your comment and It\'ll automatically be published once it\'s approved.'
  }
}

module.exports = th




// WEBPACK FOOTER //
// ./src/locales/th.js